module.exports = __webpack_public_path__ + "static/media/page-12.b54bf1a1.png";